import { calculateWaterFootprint } from "./utils";

export const saveResult = async (formData) => {
  try {
    const { personal: userData, indoor, outdoor } = formData;
    const result = calculateWaterFootprint(formData);

    await fetch(
      "https://calculess-alpha.sdplus.io/v2/carbon-calculator/water-meter",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userData,
          details: { indoor, outdoor },
          result,
        }),
      }
    );

    return result;
  } catch (error) {
    console.error("Error saving result:", error);
  }
};
